// Mitarbeiter-Modus (Admin-Fokus): Admin sieht das Portal exakt wie ein Standard-Mitarbeiter.
// Zentraler Hebel: Alle Seiten lesen den Nutzer über localStorage.getItem('user') – im Modus wird
// daraus ein Mitarbeiter ohne Spezialrechte (role 'mitarbeiter', permissions {}), real_role bleibt 'admin'.
// Muss nach `kundenansicht.js` und vor allen anderen Modulen laden.
export const FOCUS_KEY = 'admin_focus_mode';
export const FOCUS_EVENT = 'admin-focus-mode-change';

(function installMitarbeiterModusStorage() {
  try {
    const proto = Storage.prototype;
    const og = proto.getItem;
    const active = () => og.call(window.localStorage, FOCUS_KEY) === 'true';
    proto.getItem = function (k) {
      const v = og.call(this, k);
      if (k !== 'user' || this !== window.localStorage || !v || !active()) return v;
      try {
        const u = JSON.parse(v);
        if (u && u.role === 'admin') {
          return JSON.stringify({ ...u, role: 'mitarbeiter', real_role: 'admin', permissions: {} });
        }
      } catch { /* kein JSON */ }
      return v;
    };
    // Schreibschutz: Ein im Modus gelesener (abgebildeter) Nutzer darf nie als Mitarbeiter zurückgeschrieben werden
    const os = proto.setItem;
    proto.setItem = function (k, v) {
      if (k === 'user' && this === window.localStorage && typeof v === 'string' && v.includes('"real_role"')) {
        try {
          const u = JSON.parse(v);
          if (u && u.real_role) {
            const { real_role, ...rest } = u;
            v = JSON.stringify({ ...rest, role: real_role });
          }
        } catch { /* kein JSON */ }
      }
      return os.call(this, k, v);
    };
  } catch { /* Storage nicht verfügbar */ }
})();

// Jede API-Anfrage trägt im Modus den Header X-Mitarbeiter-Modus: 1 → Server behandelt den Admin exakt wie einen Mitarbeiter
const API_BASE = process.env.REACT_APP_BACKEND_URL || '';
const isApiUrl = (u) => {
  try {
    const s = typeof u === 'string' ? u : (u && u.url) || '';
    return s.includes('/api/') && (!API_BASE || s.startsWith(API_BASE) || s.startsWith('/'));
  } catch { return false; }
};
const modusActive = () => { try { return localStorage.getItem(FOCUS_KEY) === 'true'; } catch { return false; } };

(function installMitarbeiterModusFetch() {
  try {
    const of = window.fetch.bind(window);
    window.fetch = (input, init) => {
      if (modusActive() && isApiUrl(input)) {
        const headers = new Headers((init && init.headers) || (input instanceof Request ? input.headers : undefined) || {});
        headers.set('X-Mitarbeiter-Modus', '1');
        return of(input, { ...(init || {}), headers });
      }
      return of(input, init);
    };
    const oo = XMLHttpRequest.prototype.open, osend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u, ...rest) { this.__mmApi = isApiUrl(u); return oo.call(this, m, u, ...rest); };
    XMLHttpRequest.prototype.send = function (...args) {
      if (this.__mmApi && modusActive()) { try { this.setRequestHeader('X-Mitarbeiter-Modus', '1'); } catch { /* noop */ } }
      return osend.apply(this, args);
    };
  } catch { /* fetch nicht verfügbar */ }
})();

/** Echte Rolle des eingeloggten Nutzers (unabhängig vom Mitarbeiter-Modus). */
export const getRealRole = () => {
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    return u.real_role || u.role || null;
  } catch { return null; }
};

/** Nutzer-Objekt aus der API auf den Mitarbeiter-Modus abbilden (für Seiten, die /auth/me direkt lesen). */
export const applyMitarbeiterModus = (u) => {
  try {
    if (u && u.role === 'admin' && localStorage.getItem(FOCUS_KEY) === 'true') {
      return { ...u, role: 'mitarbeiter', real_role: 'admin', permissions: {} };
    }
  } catch { /* noop */ }
  return u;
};
